import React from 'react';
import { Link } from 'gatsby';

import {
  Container,
  NotFoundImage,
  DescriptionContainer,
  InfoHeader,
  InfoDescription,
  Button,
} from './notFoundBlock.styled';
import { NotFoundBlockData } from './notFoundBlock.types';

export const NotFoundBlock: React.FC<NotFoundBlockData> = (data: NotFoundBlockData) => {
  const { notFoundImage, header, description, buttonLabel, langCode } = data;
  const path = langCode === '404' ? '/' : `/${langCode}`;

  return (
    <Container>
      <NotFoundImage src={notFoundImage?.localFile?.url} alt='' />
      <DescriptionContainer>
        <InfoHeader>{header}</InfoHeader>
        <InfoDescription>{description}</InfoDescription>
      </DescriptionContainer>
      <Link to={path}>
        <Button>{buttonLabel}</Button>
      </Link>
    </Container>
  );
}
